import { jsonHeadersWithToken, parseJsonSafe } from '@/lib/constants'

/**
 * The ChatGPT & Claude screens talk to codedesign-mcp's dashboard API
 * (plan §4.8, §11.5) with the dashboard's normal x-access-token; the MCP
 * service confirms it with the backend.
 */
// Staging (dashboard.cdsn.me, on beta-api) uses the MCP test instance on the beta box until it has its own host.
const STAGING_MCP_API_URL = 'https://beta-api.codedesign.app/mcp-staging'
const onStaging = typeof window !== 'undefined' && window.location.hostname.endsWith('cdsn.me')
export const MCP_API_URL = (import.meta.env.VITE_MCP_API_URL || (onStaging ? STAGING_MCP_API_URL : 'https://mcp.codedesign.ai')).replace(/\/+$/, '')

export class AiConnectionsError extends Error {
  constructor(code, status) {
    super(code)
    this.code = code
    this.status = status
  }
}

async function request(path, { method = 'GET', body } = {}) {
  const response = await fetch(`${MCP_API_URL}/api${path}`, {
    method,
    headers: jsonHeadersWithToken(),
    body: body === undefined ? undefined : JSON.stringify(body),
  })
  const data = await parseJsonSafe(response)
  if (!response.ok) throw new AiConnectionsError((data && data.error) || `http_${response.status}`, response.status)
  return data
}

export const getAvailability = () => request('/me/availability')
export const listConnections = () => request('/connections').then((data) => data.connections || [])
export const updateConnection = (id, changes) => request(`/connections/${encodeURIComponent(id)}`, { method: 'PATCH', body: changes }).then((data) => data.connection)
export const revokeConnection = (id) => request(`/connections/${encodeURIComponent(id)}/revoke`, { method: 'POST', body: {} })
export const resumeConnection = (id) => request(`/connections/${encodeURIComponent(id)}/resume`, { method: 'POST', body: {} })
export const createKey = (choices) => request('/keys', { method: 'POST', body: choices })
export const replaceKey = (id) => request(`/keys/${encodeURIComponent(id)}/replace`, { method: 'POST', body: {} })
export const getActivity = (id, changesOnly = false) => request(`/connections/${encodeURIComponent(id)}/activity${changesOnly ? '?changes=1' : ''}`)
export const getStatus = (since) => request(`/status?since=${encodeURIComponent(since)}`).then((data) => data.connections || [])
export const getWorkspaceConnections = (workspaceId) => request(`/workspaces/${encodeURIComponent(workspaceId)}/connections`).then((data) => data.connections || [])
export const removeFromWorkspace = (workspaceId, connectionId) => request(`/workspaces/${encodeURIComponent(workspaceId)}/connections/${encodeURIComponent(connectionId)}/remove`, { method: 'POST', body: {} })
export const allowInWorkspace = (workspaceId, connectionId) => request(`/workspaces/${encodeURIComponent(workspaceId)}/connections/${encodeURIComponent(connectionId)}/allow`, { method: 'POST', body: {} })
